import { mergeViewSchema } from '../mergeViewSchema/mergeViewSchema';

/**
 * @deprecated please, use mergeViewSchema.js instead
 */
export function mergeViewIece(...args) {
  return mergeViewSchema.apply(null, args);
}
